export enum Language {
  HY = 'hy',
  EN = 'en',
  RU = 'ru',
}
